import { Component, EventEmitter, Input, Output } from '@angular/core';
import { eGENA_Checkliste } from '../../../visionet/Checkliste';
import { GlobalsSingleton } from '../../../app/core/GlobalsSingleton';

@Component({
	selector: 'SuchtyptypSelektor',
	templateUrl: 'SuchtypSelektor.html'
})
export class SuchtypSelektorComponent {

	text: string;

	@Input()
	ausgewaehlterPatiententyp: string;

	@Input()
	reanIndex: eGENA_Checkliste[] = [];

	@Input()
	activeSearch: string
	@Output()
	activeSearchChange = new EventEmitter<string>();
	
	@Input()
	curSearchResultChecklists: eGENA_Checkliste[];
	@Output()
	curSearchResultChecklistsChange = new EventEmitter<eGENA_Checkliste[]>();


	constructor(public globals: GlobalsSingleton) {
	}



	/**	=== Visionet(sl) ==========
	 *
	 *	Klick auf Suchtyp /(Reanimation, Alphabetisch, ABCDE, Körpernavigator)
	 */
	setActiveSearch(cat : string) : void {
		this.curSearchResultChecklists = []

		if (cat == "reanimation") {
			this.curSearchResultChecklists = this.reanIndex
		}
		this.activeSearch = cat

		this.curSearchResultChecklistsChange.emit(this.curSearchResultChecklists);


		this.activeSearchChange.emit(this.activeSearch);

	}


	getSelectedCssClass(buttonname : string) : string {
		if (!this.globals.isPhone()) {
			if (buttonname == this.activeSearch) {
				return "kategorie-ausgewaehlt";
			}
		}

		// Auf dem Telefon navigieren wir ja gleich beim Klick/Tipp auf den Suchtyp-Selektor. Da wollen wir keine Hervorhebung.
		return "";
	}






	

	/**	=== Visionet(sl) ==========
	 *
	 *	Lebe ich auf einem Telefon (klein) oder Tablet (groß)?
	 */
	isPhone() : boolean {
		return this.globals.isPhone();
	}



}



// WEBPACK FOOTER //
// ./src/components/Suche/SuchtypSelektor/SuchtypSelektor.ts